import { call, put, takeEvery } from 'redux-saga/effects';

import { insightsApi } from 'config/axios';
import {
    FETCH_DEMOGRAPHIC_SELECTIONS,
    FETCH_DEMOGRAPHIC_SELECTIONS_FETCHING,
    FETCH_DEMOGRAPHIC_SELECTIONS_SUCCESS,
    FETCH_DEMOGRAPHIC_SELECTIONS_FAIL
} from '../actions/ActionTypes';

// Worker
export function* fetchDemographicSelectionsSaga(action) {
    const { lang, measurementSystem } = action;

    try {
        yield put({
            type: FETCH_DEMOGRAPHIC_SELECTIONS_FETCHING
        });

        const response = yield call(
            insightsApi.get,
            `/gcs-insights/api/demographics/selections?lang=${lang}&localeUnit=${measurementSystem}`
        );

        yield put({
            type: FETCH_DEMOGRAPHIC_SELECTIONS_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_DEMOGRAPHIC_SELECTIONS_FAIL,
            data: {}
        });
    }
}

// Watcher
export const demographicSelectionsSagas = [takeEvery(FETCH_DEMOGRAPHIC_SELECTIONS, fetchDemographicSelectionsSaga)];
